// extracted by mini-css-extract-plugin
export default {"container":"Topics_container__gIe2y","list":"Topics_list__gQbtZ","header":"Topics_header__CF6Ys","topicBlock":"Topics_topicBlock__Mszwu","open":"Topics_open__9rE03"};